<script lang='ts'>
    import { ProgramType } from '@/Common/constants';
    import { getBaseBuildPeakPcnt, getDateSliderColor } from '@/Util/utils';
    import type {HTMLInputAttributes} from 'svelte/elements'
    interface $$Props extends HTMLInputAttributes{
        programType: ProgramType
        min: number
        max: number
        rampRateStats: number[]
    }
    export let value: number = 0
    export let min: number
    export let max: number
    export let programType: ProgramType
    /**
     * `Challenge -> Daily RR`
     * `Others -> Weekly RR`
     * */
    export let rampRateStats: number[]

    let bgPcnt: ReturnType<typeof getBaseBuildPeakPcnt> = null
    let sliderBG = '#9B9B9B;'
    let opacityMask = ''
    $: {
        bgPcnt = null
        opacityMask = ''
        if (programType === ProgramType.BaseBuildPeak) {
            bgPcnt = getBaseBuildPeakPcnt(min, max)
            sliderBG = `linear-gradient(to right, #9B9B9B ${bgPcnt.base}%, #4A90E2 ${bgPcnt.base}%, #4A90E2 ${bgPcnt.build}%, #7ED321 ${bgPcnt.build}%, #7ED321 ${bgPcnt.peak}%, #F5A623 ${bgPcnt.peak}%)`
        } else if (!rampRateStats) {
            sliderBG = '#5ab4bb;'
        } else {
            const sliderRange = max - min
            const todayPcnt = ((0-min) / sliderRange) * 100
            const thumbPcnt = ((value-min) / sliderRange) * 100
            sliderBG = getDateSliderColor(rampRateStats, todayPcnt, thumbPcnt, 'rgb(58, 58, 58)') // Historical days are saturated
            opacityMask = `linear-gradient(to right, rgba(0, 0, 0, 1) ${todayPcnt}%, rgba(0, 0, 0, 0.4) ${todayPcnt}%)`
        }
    }
</script>

<!-- 
This is only a wrapper for the styling of the input component. A label tag is
still required for accessibility guidelines. 
-->

<div class="slider-container relative" style={`--tpDateSliderBG: ${sliderBG}; --maskBG: ${opacityMask}`}>
    <input {...$$restProps} class="select-slider my-3 min-h-[11px]" type="range" bind:value {min} {max} on:input on:change/>

    {#if programType === ProgramType.BaseBuildPeak}
        {#if bgPcnt.build > 15}
            <span style={`left: ${(bgPcnt.build + bgPcnt.base)/2}%;`}>Base</span>
        {/if}
        {#if bgPcnt.peak > 15}
            <span style={`left: ${(bgPcnt.peak + bgPcnt.build)/2}%;`}>Build</span>
        {/if}
        <span style={`left: ${(100 + bgPcnt.peak)/2}%;`}>Peak</span>
    {/if}
</div>

<style lang="scss">
    .slider-container {
        max-width: 100%;
        width: 100%;

        span {
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%);
            font-weight: bold;
            color: white;
            pointer-events: none;
        }

        &:before {
            background: var(--tpDateSliderBG);
            mask-image: var(--maskBG);
            border-radius: 4px !important;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 100%;
            content: "";
        }
    }
    .select-slider {
        -webkit-appearance: none;
        appearance: none;
        height: 30px;
        outline: none;
        position: relative;
        background: transparent;

        &::-webkit-slider-thumb {
            -webkit-appearance: none;
            appearance: none;
            width: 10px;
            height: 40px;
            background: #ffffff;
            border-radius: 7px !important;
            cursor: pointer;
            box-shadow: 0 0 4px 0 rgba(0,0,0,0.5);
        }

        &::-moz-range-thumb{
            width: 10px;
            height: 40px;
            background: #ffffff;
            border-radius: 7px !important;
            cursor: pointer;
            box-shadow: 0 0 4px 0 rgba(0,0,0,0.5);
        }

        &:disabled {
            cursor: not-allowed;

            &::-moz-range-thumb {
                background-color: #d7d7d7;
            }
            &::-webkit-slider-thumb {
                background-color: #d7d7d7;
            }
        }

        &:focus{
            outline: none;
        }
    }
</style>